import { ModalFullCentered } from '../../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../../baseComponents/Modal/types'
import NullComponent from '../../../../../../baseComponents/NullComponent'
import InputTable from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { ColumnOrderTableSchema, OrderData, SetCompleteDataTy } from '../../../OrderLayout/types'
import { useOrderLayoutTableLogic } from '../../../OrderLayout/OrderTable/useOrderLayoutTableLogic'
import { sellOrderStatusInversed } from '@teinor/erp/types/company/order/sell/sellOrder'
import { SellOrderProductModelTypeExtended } from '@teinor/erp/types/company/order/sell/sellOrder/sellOrderProduct'
import { ProductExtendedTyInputTableListing } from '../../../../../Product/types'
import { sellOrderLayoutComponents } from '../..'
import { useCallback, useMemo, useState } from 'react'
import { ColumnITLayoutTableConfiguration, ITHookFunctionTy, ITLayoutTableOnChangeInputs } from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { SwitchButton, TabItems } from '../../../../../../baseComponents/Button/SwitchButton'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { addDictionaryExtraLine, TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { filterTableDataPrepareOrder, getExtraSelectedData, parseDataToServedOrderTD, parseSelectedProductsToUpdate, restoreDataFromLocalStorage } from './functions'
import { ServedOrderTDTy, TypeFieldSearchTyKeys } from './types'
import { CustomRenderString, DeleteRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ITDiscountDisplay, ITTypeQuantityDisplay } from '../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { updateTableQuantityScaled, updateTableQuantityScaledByWeight } from '../../../OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditAddonProductOrder/functions'
import './modalPrepareOrder.sass'
import { TableWithoutVirtualListingRowRenderer } from '../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing/types'
import { TableWithoutDefaultRowRenderer } from '../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import { recalculateAllQuoteOrderRows } from '@teinor/erp/prices/quote/calculate'
import { getAllWorkingCenters } from '../../../../../../utils/reducers/getters'
import { numToDecimals } from '@teinor/erp/prices'
import { CustomSelectWithSearchBar } from '../../../../../../forms/CustomSelect'
import { WorkSheetGroupStatusesPayload } from '../../../../../../utils/reducers/sells/workSheetGroupStatus'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { DictionaryComponents } from '../../../../../../utils/globals/types'
import { SelectorProductsOrderGroup, SelectorProductsOrderSingle, SelectorProductsOrderTotal } from './subcomponents'
import FooterInputTableModalSelect, { FooterLeftInputTableModalComponentProps } from '../../../../FooterInputTableModalSelect'
import { ButtonSecondary } from '../../../../../../baseComponents/Button'
import { faXmark } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../../../../baseComponents/TwinIcon'
import { flushSync } from 'react-dom'

type ModalPrepareOrderProps = ModalPrepareOrderLogicProps & ReduxWorkSheetGroupStatus & {}

const ModalPrepareOrder: React.FC<ModalPrepareOrderProps> = ({ Order, workSheetGroupStatuses, ...logic }) => {
    const { activeTab, changeTab, setSelectedProduct, servedOrderTD, addProductTable, addQuantity, selectedProduct, memoTableData, confirmProductTable, setServedOrderTD, rowRenderer, typeFieldSearch, changeTypeFieldSearch, loading, filterWorksheetProductStatusId, setFilterWorksheetProductStatusId, restoreBackup, cleanLocalStore } = useModalPrepareOrderLogic({ ...logic, Order, workSheetGroupStatuses })

    const { tVars, t } = useTwinTranslation()
    const items: TabItems[] = [
        {
            element: <TwinTrans transKey={'total'}>Total</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'groups'}>Grupos</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'singles'}>Individuales</TwinTrans>
        },
    ]
    const itemsTypeField: TabItems[] = [
        {
            element: <TwinTrans transKey={'reference'}>Referencia</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'codeBar'}>Código de barras</TwinTrans>
        },
    ]

    const dictLabel ={
        0: t('reference', 'Referncia'),
        1: t('codeBar', 'Código de barras')
    }

    const myColumns = useMemo(() =>{
        const statusColumn: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & SellOrderProductModelTypeExtended> = []
        const workingCenters = getAllWorkingCenters()
        const dictWarehouses = workingCenters?.[Order?.header?.WorkingCenter?.id]?.dictWarehouses
        if (Order?.header.WorkSheetId || Order?.header?.relatedWorkSheets?.length) {
            statusColumn.push(
                {
                    id: 'WorkSheetProductStatusId',
                    dataKey: 'WorkSheetProductStatusId',
                    label: '',
                    simpleLabel: t('workSheetStatus', 'Estado hoja de trabajo'),
                    component: 'OrderProductWorkSheetStatus',
                    hideColumnByDefault: true,
                    Order: Order?.header || {},
                    extraToolTipStr: 'modal_prepare_order'
                },
            )
        }
        const columns: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & SellOrderProductModelTypeExtended> = [
            {
                id: 'nLine',
                dataKey: 'nLine',
                label: t('line', 'Línea'),
                width: 70,
                hideColumnByDefault: true
            },
            {
                id: 'url',
                dataKey: 'url',
                label: t('image', 'Imagen'),
                component: 'ITDisplayImage',
                width: 70
            },
            {
                id: 'code_bar',
                dataKey: 'code_bar',
                label: t('codeBarShort', 'Cod. de barras'),
                simpleLabel: t('codeBar', 'Código de barras'),
                component: 'OrderSearchProductInputCreate',
                field: 'code_bar',
                typeOnChange: 'onChangeAdd',
                sortable: true,
                hideColumnByDefault: true,
                minWidth: 115
            },
            {
                id: 'reference',
                dataKey: 'reference',
                label: t('reference', 'Referencia'),
                component: 'OrderSearchProductInput',
                field: 'reference',
                sortable: true,
                minWidth: 100,
                hideColumnByDefault: true,
                className: 'quote_order_reference_name'
            },
            {
                id: 'name',
                dataKey: 'name',
                label: t('name', 'Nombre'),
                component: 'OrderSearchProductInputName',
                field: 'name',
                sortable: true,
                hideColumnByDefault: true,
                className: 'quote_order_reference_name'
            },
            {
                id: 'referenceAndName',
                dataKey: 'name',
                label: t('referenceName', 'Referencia y nombre'),
                component: 'OrderSearchProductInputReferenceAndName',
                field: 'referenceAndName',
                sortable: true,
                minWidth: 180,
                className: 'quote_order_reference_name'
            },
            {
                id: 'descriptionDocuments',
                dataKey: 'descriptionDocuments',
                label: t('description', 'Descripción'),
                customRender: (parameterValue) => <CustomRenderString value={parameterValue} className='twin_elipsis' />,
                hideColumnByDefault: true
            },
            {
                id: 'shortDescriptionDocuments',
                dataKey: 'shortDescriptionDocuments',
                label: t('shortDescriptionS', 'Desc. corta'),
                simpleLabel: t('shortDescription', 'Descripción corta'),
                customRender: (parameterValue) => <CustomRenderString value={parameterValue} />,
                hideColumnByDefault: true
            },
            {
                id: 'notes',
                dataKey: 'notes',
                label: t('notes', 'Notas'),
                customRender: (parameterValue) => <CustomRenderString value={parameterValue} className='twin_elipsis' />
            },
            {
                id: 'SpecificPriceRuleId',
                dataKey: 'SpecificPriceRuleId',
                label: t('priceRule', 'Tarifa'),
                customRender: (parameterValue, allRowData) => <CustomRenderString value={'T' + allRowData?.['SpecificPriceRule.id'] + ' - ' + allRowData?.['SpecificPriceRule.name']} className='twin_elipsis' />,
                hideColumnByDefault: true
            },
            {
                id: 'initialUnitPriceWithoutTax',
                dataKey: 'initialUnitPriceWithoutTax',
                label: () => <div className='text-right mr-15 w-full'>{t('price', 'Precio')}</div>,
                simpleLabel: t('price', 'Precio'),
                component: 'ITDisplayPrice',
                width: 100,
            },
            {
                id: 'quantity',
                dataKey: 'quantity',
                label: t('quantityServedShort2', 'Cant. serv.'),
                width: 110,
                component: 'ITInputQuantity',
                typeOnChange: 'onChangeTotalsFetch',
                simpleLabel: t('quantityServed', 'Cantidad servida'),
                toolTip: t('quantityServed', 'Cantidad servida'),
                skipMinQuantity: true
            },
            {
                id: 'quantity2',
                dataKey: 'quantity2',
                label: t('quantitySecondRes', 'Cant. sec.'),
                simpleLabel: t('quantitySecondary', 'Cantidad secundaria'),
                width: 90,
                customRender: (parameterValue, allRowData) => <ITTypeQuantityDisplay measure={allRowData.typeQuantity2} value={parameterValue} />,
                hideColumnByDefault: true
            },
            {
                id: 'wasteWeight',
                dataKey: 'wasteWeight',
                label: t('wasteWeight', 'Merma'),
                customRender: (parameterValue) => <CustomRenderString value={parameterValue ? parameterValue + ' %' : ''} />,
                width: 100,
                hideColumnByDefault: true,
            },
            {
                id: 'desiredQuantity',
                dataKey: 'desiredQuantity',
                label: t('desiredQuantityShort', 'Cant. des.'),
                simpleLabel: t('desiredQuantity', 'Cantidad deseada'),
                toolTip: t('desiredQuantity', 'Cantidad deseada'),
                width: 105,
                component: 'ITInputQuantity',
                readOnlyFnc: () => true
            },
            {
                id: 'discount',
                dataKey: 'discount',
                label: t('discount', 'Descuento'),
                width: 90,
                customRender: (parameterValue, allRowData) => <ITDiscountDisplay CurrencyId={Order?.header.CurrencyId} value={parameterValue} typeDiscount={allRowData.typeDiscount} />
            },
            {
                id: 'WarehouseId',
                dataKey: 'WarehouseId',
                label: t('warehouse', 'Almacén'),
                minWidth: 110,
                hideColumnByDefault: true,
                customRender: (parameterValue, allRowData) => <CustomRenderString value={parameterValue ? dictWarehouses?.[parameterValue as any]?.name || '' : ''} />
            },
            ...statusColumn
        ]
        return columns
    }, [t, Order?.header])

    let totalUnits = 0
    for (const element of servedOrderTD.tableData) {
        totalUnits += parseFloat(element.quantity)
    }
    const dictSelectorProductComponents: DictionaryComponents = {
        0: SelectorProductsOrderTotal,
        1: SelectorProductsOrderGroup,
        2: SelectorProductsOrderSingle
    }
    const SelectorProductComponent = dictSelectorProductComponents?.[activeTab]
    const footerLeftComponents: FooterLeftInputTableModalComponentProps[] = [
        {
            label: t('units', 'Unidades'),
            children: <span className='medium14'>{totalUnits}</span>
        },
        {
            label: t('lines', 'Líneas'),
            children: <span className='medium14'>{servedOrderTD.tableData.length}</span>
        },
    ]
    return (
        <ModalFullCentered className='modal_prepare_order' opened={true} setOpened={logic.setOpened} onClickOut={false}>
            <div className='flex items-center mb-20'>
                <h2>{tVars('prepareOrderCustomerName', 'Preparar pedido {{orderN}} - {{customerName}}', { orderN: Order.header.custom_name || Order.header.full_assigned_number, customerName: Order.header.Customer.fiscal_name || Order.header.Customer.name })}</h2>
                <SwitchButton className='ml-30' items={items} onClick={changeTab} active={activeTab} />
                <SwitchButton className='ml-30' items={itemsTypeField} onClick={(val) => changeTypeFieldSearch(val as TypeFieldSearchTyKeys)} active={typeFieldSearch} />
                {Order.header?.WorkSheet ? <CustomSelectWithSearchBar className='ml-30 w-200' label={t('filterBy', 'Filtrar por')} items={addDictionaryExtraLine(workSheetGroupStatuses?.dictWorkSheetGroupStatus[Order.header?.WorkSheet?.WorkSheetGroupStatusId]?.WorkSheetProductStatusesDict || {})} value={filterWorksheetProductStatusId || undefined} sortItems={true} onChange={(val) => setFilterWorksheetProductStatusId(val)} /> : null}
                {servedOrderTD.showRestoreButton ? <ButtonSecondary className='ml-30' onClick={restoreBackup}><TwinTrans transKey='restoreBackup'>Restaurar copia</TwinTrans></ButtonSecondary> : null}
                <div className='ml-auto'>
                    <TwinIcon className='cursor-pointer w-20 h-20' icon={faXmark} onClick={() => logic.setOpened(null)} />
                </div>
            </div>
            <div className=' mb-20 modal_prepare_order_selector flex'>
                <SelectorProductComponent label={dictLabel?.[typeFieldSearch] || ''} selectedProduct={selectedProduct || undefined} {...{ Order, setSelectedProduct, selectedProducts: servedOrderTD.selectedProducts, addProductTable, addQuantity, servedOrderTD, typeFieldSearch, filterWorksheetProductStatusId: filterWorksheetProductStatusId || undefined }} servedOrderTD={servedOrderTD} />
            </div>
            <InputTable modelId='SellOrderId' className='modal_prepare_order_table' TableChildren={NullComponent} userPermissions={{ n: 1, permission: 'read' }} completeData={{ ...Order, ...servedOrderTD, tableData: memoTableData.tableData, dictPosTableData: memoTableData.dictPosTable }} CurrencyId={Order.header.CurrencyId} columns={myColumns} setCompleteData={setServedOrderTD as any} getCompleteData={async () => { } } inputTableURLs={{} as any} orderHeaderURLs={{} as any} setTableConfiguration={() => { } } tableConfiguration={{} as any} name='prepareOrderSellPrepareOrderWaitingResponse' hookFunction={useMyPrepareOrderHook} orderStatusDict={sellOrderStatusInversed} components={sellOrderLayoutComponents} rowRenderer={rowRenderer}/>
            <FooterInputTableModalSelect setOpened={() => logic.setOpened(null)} textAccept={t('save', 'Guardar')} textCancel={t('cancel', 'Cancelar')} onAccept={confirmProductTable} disabled={servedOrderTD?.tableData?.length ? false : true} footerLeftComponents={footerLeftComponents} loading={loading} onCancel={cleanLocalStore}/>
        </ModalFullCentered>
    )
}

type ModalPrepareOrderLogicProps = {
    Order: OrderData
    setOpened: ModalOpenedSetTy
    setCompleteData: SetCompleteDataTy
    workSheetGroupStatuses: WorkSheetGroupStatusesPayload
}

const useModalPrepareOrderLogic = ({ setCompleteData, setOpened, Order, workSheetGroupStatuses }: ModalPrepareOrderLogicProps) => {
    const {loading, startLoading} = useIsLoading()
    const [activeTab, setActiveTab] = useState<number>(0)
    const [typeFieldSearch, setTypeFieldSearch] = useState<TypeFieldSearchTyKeys>(0)
    const [servedOrderTD, setServedOrderTD] = useState<ServedOrderTDTy>(parseDataToServedOrderTD(JSON.parse(JSON.stringify(Order))))
    const [selectedProduct, setSelectedProduct] = useState<TwinDictionary | null>(null)
    const [filterWorksheetProductStatusId, setFilterWorksheetProductStatusId] = useState<number | null>(workSheetGroupStatuses?.dictWorkSheetGroupStatus?.[Order.header?.WorkSheet?.WorkSheetGroupStatusId]?.DefaultWorkSheetProductStatusId || null)
    const memoTableData = useMemo(() => filterTableDataPrepareOrder(servedOrderTD), [servedOrderTD])

    const changeTab = useCallback((val: number) => {
        setActiveTab(val)
        setSelectedProduct(null)
    }, [setActiveTab])

    const changeTypeFieldSearch = useCallback((val: TypeFieldSearchTyKeys) => {
        setTypeFieldSearch(val)
        setSelectedProduct(null)
    }, [setTypeFieldSearch])

    const addQuantity = useCallback((id: number, value: number) => {
        let myPos = 0
        flushSync(async () => {
            await setServedOrderTD((old)=>{
                const copyOld = JSON.parse(JSON.stringify(old))
                const pos = copyOld.selectedProducts?.[id]?.posTableData
                myPos = pos
                const myProduct = copyOld.selectedProducts[id]
                const quantity = parseFloat(String(myProduct.quantity)) + parseFloat(String(value))
                copyOld.selectedProducts[id].quantity = quantity
                copyOld.tableData[pos].quantity = quantity
                copyOld.tableData[pos].quantity2 = numToDecimals(quantity * parseFloat(String(copyOld.tableData[pos].quantity2base)), 8)
                return copyOld
            })
            const selectedOrderProducts = window.localStorage.getItem(`selectedOrderProducts${Order.header.id}`) || '[]'
            const parsedPreparedProducts = JSON.parse(selectedOrderProducts)
            parsedPreparedProducts[myPos].quantity += value
            window.localStorage.setItem(`selectedOrderProducts${Order.header.id}`, JSON.stringify(parsedPreparedProducts))
        })
    }, [setServedOrderTD, Order.header.id])

    const addProductTable = useCallback((product: TwinDictionary, localStorage: boolean = true) => {
        let resetLocalStorage = false
        setServedOrderTD((old)=>{
            const copyOld = JSON.parse(JSON.stringify(old))
            const parsedId = product.id
            if (Object.keys(copyOld?.selectedProducts).length === 0 && localStorage){
                resetLocalStorage = true
                window.localStorage.setItem(`selectedOrderProducts${Order.header.id}`, JSON.stringify([{ id: product.id, quantity: product.quantity }]))
                copyOld.showRestoreButton = false
            }
            if (!copyOld?.selectedProducts?.[parsedId]) {
                product.quantity2 = numToDecimals(parseFloat(String(product.quantity)) * parseFloat(String(product.quantity2base)))
                product.parsedId = parsedId
                copyOld.tableData.push(product)
                const selectedQuantity = parseFloat(String(copyOld.selectedProducts?.[parsedId]?.quantity || 0)) + parseFloat(String(product?.quantity))
                copyOld.selectedProducts[parsedId] = { ...product, quantity: selectedQuantity, posTableData: copyOld.tableData.length - 1 }
            }else{
                const myProduct = copyOld.selectedProducts?.[parsedId]
                const quantity = parseFloat(String(myProduct.quantity)) + parseFloat(String(product.quantiy))
                product.quantity2 = numToDecimals(quantity * parseFloat(String(product.quantity2base)), 8)
                copyOld.tableData[myProduct.posTableData].quantity = quantity
                copyOld.selectedProducts[parsedId] = { ...product, quantity }
            }
            copyOld.dictPosTableData = {}
            for (const key in copyOld.tableData) {
                const element = copyOld.tableData[key]
                const myParsedKey = parseInt(key)
                element.absoluteIndex = myParsedKey
                copyOld.dictPosTableData[element.parsedId] = myParsedKey
            }
            return copyOld
        })
        if (localStorage && !resetLocalStorage){
            const selectedOrderProductsArray = window.localStorage.getItem(`selectedOrderProducts${Order.header.id}`) || '[]'
            const parsedSelectedOrderProducts = JSON.parse(selectedOrderProductsArray)
            parsedSelectedOrderProducts.push({id: product.id, quantity: product.quantity})
            window.localStorage.setItem(`selectedOrderProducts${Order.header.id}`, JSON.stringify(parsedSelectedOrderProducts))
        }
    }, [setServedOrderTD, Order.header.id])

    const confirmProductTable = useCallback(async () => {
        startLoading()
        const extraSelectedData = getExtraSelectedData(servedOrderTD)
        const {result, justIds} = parseSelectedProductsToUpdate(servedOrderTD?.tableData)
        let subIds: TwinDictionary[] = []
        const idsSelected: number[] = []
        const myFetchResult: TwinDictionary[] = []
        await setCompleteData((old)=>{
            if(!old){
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            for (const element of copyOld.tableData) {
                element.selected = false
            }
            for (const item of result) {
                copyOld.tableData[item.inventPosition] = { ...copyOld.tableData?.[item.inventPosition], quantity: item.quantity, quantity2: item.quantity2, selected: true}
                idsSelected.push(item.id)
                const myItem = copyOld.tableData[item.inventPosition]
                if (myItem?.type === 'productCombinedHeaderAddon' || myItem?.OrderProductId) {
                    const OrderProductId = myItem.id
                    for (let i = item.inventPosition + 1; i < copyOld?.tableData.length; i++) {
                        const element = copyOld?.tableData[i]
                        if (element?.OrderProductId && element?.OrderProductId === OrderProductId) {
                            element['selected'] = true
                            subIds.push({ id: element.id })
                            idsSelected.push(element.id)
                        } else {
                            break
                        }
                    }
                }
                myFetchResult.push(item)
                const related = updateTableQuantityScaled(copyOld, item.id, item.quantity)
                if(related.length){
                    for (const relatedProduct of related) {
                        copyOld.tableData[relatedProduct.inventPosition] = { ...copyOld.tableData[relatedProduct.inventPosition], quantity: relatedProduct.quantity, quantity2: relatedProduct.quantity2, selected: true}
                        myFetchResult.push({...relatedProduct, isChanging: true})
                    }
                }
                const relatedWeight = updateTableQuantityScaledByWeight(copyOld, item.id, item.quantity2)
                if (relatedWeight.length){
                    for (const relatedProductWeight of relatedWeight) {
                        copyOld.tableData[relatedProductWeight.inventPosition] = { ...copyOld.tableData[relatedProductWeight.inventPosition], quantity: relatedProductWeight.quantity, quantity2: relatedProductWeight.quantity2, selected: true}
                        myFetchResult.push({...relatedProductWeight, isChanging: true})
                    }
                }
            }
            copyOld.extraSelectedData = extraSelectedData
            copyOld.selectedTableData = [...justIds, ...subIds]
            recalculateAllQuoteOrderRows(copyOld)
            return {...copyOld}
        })
        await twinFetchPostJSON('/api/app/order/sell/sellOrder/orderProduct/updateSellOrderProductBulk', { bulkUpdateProducts: myFetchResult })
        setOpened(null)
    }, [setCompleteData, setOpened, startLoading, servedOrderTD])

    const cleanLocalStore = useCallback(() => {
        window.localStorage.removeItem(`selectedOrderProducts${Order.header.id}`)
    }, [Order.header.id])

    const restoreBackup = useCallback(() => {
        const selectedOrderProducts = window.localStorage.getItem(`selectedOrderProducts${Order.header.id}`) || '[]'
        const parsedPreparedProducts = JSON.parse(selectedOrderProducts)
        const matchedProducts = restoreDataFromLocalStorage(parsedPreparedProducts, { tableData: Order.tableData, dictPosTableData: Order.dictPosTableData }, servedOrderTD.selectedProducts, filterWorksheetProductStatusId)
        for (const product of matchedProducts) {
            addProductTable(product, false)
        }
        setServedOrderTD((old) => {
            return { ...old, showRestoreButton: false }
        })
    }, [Order.tableData, Order.dictPosTableData, servedOrderTD.selectedProducts, filterWorksheetProductStatusId, addProductTable, Order.header.id])

    const rowRenderer: TableWithoutVirtualListingRowRenderer = useCallback((props) => {
        let extraClassName = ''
        if(props.rowIndex === 0){
            extraClassName += 'modal_prepare_order_first_row'
        }
        return <TableWithoutDefaultRowRenderer {...props} className={(props.className || '') + ' ' + extraClassName} />
    }, [])

    return { servedOrderTD, setServedOrderTD, activeTab, setSelectedProduct, addProductTable, addQuantity, selectedProduct, memoTableData, confirmProductTable, changeTab, rowRenderer, typeFieldSearch, changeTypeFieldSearch, loading, filterWorksheetProductStatusId, setFilterWorksheetProductStatusId, restoreBackup, cleanLocalStore }
}

const useMyPrepareOrderHook: ITHookFunctionTy = (props) => {
    const { eventFunctions, addCustomRender,  ...rest} = useOrderLayoutTableLogic(props)
    const {t} = useTwinTranslation()
    const deleteMsg = t('delete', 'Eliminar')

    const myOnChange: ITLayoutTableOnChangeInputs = useCallback((rowIndex, keyValue, value) => {
        props.setCompleteData((old) => {
            if (!old) {
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            if (copyOld.tableData[rowIndex]?.[keyValue]){
                const product = copyOld.tableData[rowIndex]
                copyOld.tableData[rowIndex][keyValue] = value
                copyOld.tableData[rowIndex].quantity2 = numToDecimals(parseFloat(String(value)) *parseFloat(String(copyOld.tableData[rowIndex].quantity2base)), 8)
                copyOld.selectedProducts[product.id][keyValue] = value
            }
            return copyOld
        })

        const selectedOrderProducts = window.localStorage.getItem(`selectedOrderProducts${props.completeData.header.id}`) || '[]'
        const parsedPreparedProducts = JSON.parse(selectedOrderProducts)
        parsedPreparedProducts[rowIndex][keyValue] = value
        window.localStorage.setItem(`selectedOrderProducts${props.completeData.header.id}`, JSON.stringify(parsedPreparedProducts))
    }, [props])

    const deleteLine = useCallback((rowIndex: number) => {
        props.setCompleteData((old )=>{
            if(!old){
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            const product = copyOld.tableData[rowIndex]
            delete copyOld.selectedProducts[product.parsedId]
            copyOld.tableData.splice(rowIndex, 1)
            copyOld.dictPosTableData = {}
            for (const key in copyOld.tableData) {
                const element = copyOld.tableData[key]
                const myParsedKey = parseInt(key)
                element.absoluteIndex = myParsedKey
                copyOld.dictPosTableData[element.parsedId] = myParsedKey
            }
            return copyOld
        })

        const selectedOrderProducts = window.localStorage.getItem(`selectedOrderProducts${props.completeData.header.id}`) || '[]'
        const parsedPreparedProducts = JSON.parse(selectedOrderProducts)
        parsedPreparedProducts.splice(rowIndex, 1)
        window.localStorage.setItem(`selectedOrderProducts${props.completeData.header.id}`, JSON.stringify(parsedPreparedProducts))
    }, [props])
    
    const parseColumns = useCallback((columns: ColumnITLayoutTableConfiguration[]) => {
        let result = addCustomRender(columns as any, {
            onChange: myOnChange,
            onChangeAdd: myOnChange as any,
            onChangeFetch: myOnChange,
            onChangeTotals: myOnChange,
            onChangeTotalsFetch: myOnChange
        })
        return result
    }, [addCustomRender, myOnChange])

    const columns = props.columns
    const parsedColumns = useMemo(() => parseColumns([...columns, {
        id: 'delete',
        dataKey: 'delete',
        label: '',
        simpleLabel: deleteMsg,
        customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => deleteLine(allRowData.absoluteIndex || allRowData.rowIndex)} />,
        width: 30
    }]), [columns, parseColumns, deleteMsg, deleteLine])

    return {...rest, parsedColumns, eventFunctions, addCustomRender}
}




const workSheetGroupStatusesDispatch = {
    setWorkSheetGroupStatuses: (payload: WorkSheetGroupStatusesPayload) => ({ type: 'CHANGE_WORKSHEETGROUPSTATUSES', payload }),
}

export type ReduxWorkSheetGroupStatus = ConnectedProps<typeof workSheetGroupStatusConnect>
const mapWorkSheetGroupStatusConnector = (state: AllReduxPayloads) => ({ workSheetGroupStatuses: state.workSheetGroupStatuses })
const workSheetGroupStatusConnect = connect(mapWorkSheetGroupStatusConnector, workSheetGroupStatusesDispatch)
const workSheetGroupStatusConnectLoading = withLoading(ModalPrepareOrder, [{ fetchUrl: '/api/app/order/sell/workSheet/workSheetGroupStatus/getAllWorkSheetGroupStatusesComplete', propName: 'workSheetGroupStatuses', setFunctionName: 'setWorkSheetGroupStatuses' }])
const ModalPrepareOrderConnect = workSheetGroupStatusConnect(workSheetGroupStatusConnectLoading)

export default ModalPrepareOrderConnect